const move = (array, from, to) => {
    if (to >= array?.length) {
        let k = to - array?.length + 1;
        while (k--) {
            array.push(undefined);
        }
    }
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
};

const chunk = (array, size) => {
    const chunked = [];
    for (let i = 0; i < array?.length; i += size) {
        chunked.push(array.slice(i, i + size));
    }
    return chunked;
};

export default {
    move,
    chunk
};